import React from "react";
import { Box, Typography } from "@mui/material";
import { tokens } from "../../theme";
import { IconClock } from "../ui/icons";

const Tick = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="3"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12.5l4.5 4.5L19 7" />
  </svg>
);

/**
 * Qué falta para cerrar la orden. Evita el clásico "le di a finalizar y me
 * saltó un error": lo que falta se ve antes de intentarlo.
 */
const OrderChecklist = ({ formState }) => {
  const items = [
    {
      label: "Cliente elegido",
      done: Boolean(formState.client?.name || formState.client?.company),
    },
    { label: "Descripción cargada", done: Boolean(formState.description) },
    {
      label: "Fotos del trabajo",
      done: (formState.pictures || []).length > 0,
      optional: true,
    },
    { label: "Firma del cliente", done: Boolean(formState.signature) },
  ];

  return (
    <Box
      sx={{
        backgroundColor: tokens.surface,
        border: `1px solid ${tokens.border}`,
        borderRadius: `${tokens.radiusCard}px`,
        padding: "16px 16px 14px",
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <Typography sx={{ fontSize: "14px", fontWeight: 600 }}>Antes de cerrar</Typography>

      {items.map((item) => (
        <Box key={item.label} sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Box
            sx={{
              width: 20,
              height: 20,
              flexShrink: 0,
              borderRadius: 999,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: item.done ? "var(--sup-state-ok-bg)" : "var(--sup-state-warn-bg)",
              color: item.done ? "var(--sup-state-ok-ink)" : "var(--sup-state-warn-ink)",
            }}
          >
            {item.done ? <Tick /> : <IconClock size={12} />}
          </Box>

          <Typography sx={{ fontSize: "13px", color: tokens.ink2, flexGrow: 1 }}>
            {item.label}
          </Typography>

          {!item.done && (
            <Typography
              sx={{
                fontSize: "12px",
                fontWeight: 500,
                color: item.optional ? tokens.ink3 : "var(--sup-state-warn-ink)",
              }}
            >
              {item.optional ? "Opcional" : "Falta"}
            </Typography>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default OrderChecklist;
